import React, { useState, useEffect } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useNavigate, Link } from "react-router-dom";
import Toast from "../components/Toast/Toast";
import "../styles/Login.css"; // Reuse the nice login CSS
import { FcGoogle } from "react-icons/fc";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [toast, setToast] = useState(null); // { message, type }
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        setTimeout(() => navigate("/"), 400); // small delay to allow toast
      }
    });
    return unsub;
  }, [navigate]);

  const showToast = (message, type = "info") => {
    setToast({ message, type });
  };

  // Email/password registration
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    showToast("", "info");
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        role: "user",
      });
      showToast("Registration successful!", "success");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      let msg = "Registration failed.";
      if (err.code === "auth/email-already-in-use") {
        msg = "That email is already registered.";
      } else if (err.code === "auth/weak-password") {
        msg = "Password should be at least 6 characters.";
      }
      showToast(msg, "error");
    } finally {
      setIsLoading(false);
    }
  };

  // Google sign-up
  const handleGoogleRegister = async () => {
    setIsLoading(true);
    showToast("", "info");
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // Write user to Firestore if new
      await setDoc(
        doc(db, "users", user.uid),
        {
          email: user.email,
          role: "user",
        },
        { merge: true }
      );
      showToast("Signed up with Google!", "success");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      showToast("Google registration failed.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Create Account</h2>
        <input
          type="email"
          placeholder="Email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />
        <input
          type="password"
          placeholder="Password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isLoading}
        />
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Registering..." : "Register"}
        </button>
        
        <div className="login-divider">
          <span>or</span>
        </div>

        <button
          type="button"
          className="google-signin-btn"
          onClick={handleGoogleRegister}
          disabled={isLoading}
        >
          <FcGoogle style={{ fontSize: 22, marginRight: 12, verticalAlign: "middle" }} />
          Sign up with Google
        </button>
        <div
          style={{
            marginTop: "1.2rem",
            fontSize: "0.95rem",
            color: "#3c2f1e",
            textAlign: "center",
          }}
        >
          Already have an account?{" "}
          <Link
            to="/login"
            style={{
              color: "#a67800",
              fontWeight: 600,
              textDecoration: "underline",
              marginLeft: "0.25rem",
            }}
          >
            Login
          </Link>
        </div>
      </form>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
